export const types = {
  setOne: "[knox] setOne",
  setAll: "[knox] setAll",
};
